import * as React from "react"
const ClickIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={12}
        height={16}
        fill="none"
        {...props}
    >
        <path
            fill={props.fill || "#CBCBCB"}
            d="M6 16c-1.667 0-3.083-.583-4.25-1.75C.583 13.083 0 11.667 0 10V6c0-1.667.583-3.083 1.75-4.25C2.917.583 4.333 0 6 0c1.667 0 3.083.583 4.25 1.75C11.417 2.917 12 4.333 12 6v4c0 1.667-.583 3.083-1.75 4.25C9.083 15.417 7.667 16 6 16Zm.75-10.5h3.708a4.373 4.373 0 0 0-1.187-2.583A4.353 4.353 0 0 0 6.75 1.583V5.5Zm-5.208 0H5.25V1.583c-1 .153-1.84.594-2.52 1.323A4.42 4.42 0 0 0 1.541 5.5ZM6 14.5c1.245 0 2.306-.439 3.184-1.316.877-.878 1.316-1.939 1.316-3.184V7h-9v3c0 1.245.439 2.306 1.316 3.184C3.694 14.06 4.755 14.5 6 14.5Z"
        />
    </svg>
)
export default ClickIcon
